import styled from 'styled-components';
import colors from '../../../../../../constants/colors';

const Wrapper = styled.div`
  border-bottom: 1px solid ${colors.main.dividers};
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 23px;

  &:last-child {
    border-bottom: none;
  }

  &:not(:last-of-type) {
    margin-bottom: 23px;
  }
`;

export default Wrapper;
